export const EMPTY_OBJECT: Readonly<Record<string,unknown>> = Object.freeze(Object.create(null))
export const EMPTY_ARRAY: ReadonlyArray<any> = Object.freeze([])
export const NOOP: AnyFn = Object.freeze(() => {/* do nothing*/})
export const EMPTY_SET = Object.freeze(new Set<any>());

export const AUSTRALIA_COUNTRY_ID: string|number = 14;
